// extracted by css-extract-rspack-plugin
export default {"take":"TakeRestHeight_take__Ll7bx"};